import React, { useEffect, useState } from 'react';
import GDPR from '../../components/controls/GDPR';
import { useNavigate } from 'react-router';
import useAuthUtils from '../../utils/useAuthUtils';
import Button from '../../components/controls/Button';
import { apiPOST } from '../../utils/networking';
import { From } from '../../components/controls/Form';
import { DEV_MODE } from '../../utils/Constants';
import Heading from '../../components/controls/Typography/Heading';

import './gdpr.less';

export const GDPRPage = () => {
  const navigate = useNavigate();
  const auth = useAuthUtils();
  const [isBusy, setIsBusy] = useState(false);
  const [inGDPRCountry, setInGDPRCountry] = useState((/** @type {Boolean|null} */(null)));
  const [gdprReadConsent, setGdprReadConsent] = useState((/** @type {Boolean|null} */(null)));
  const [formErrorMessage, setFormErrorMessage] = useState('');

  const handleFormSubmit = async () => {
    setFormErrorMessage('');
    setIsBusy(true);
    try {
      await apiPOST('/recommendation/rest/gdpr', {
        inGDPRCountry,
        gdprReadConsent,
      });
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      window.scrollTo(0, 0);
      setFormErrorMessage('Unexpected error. Please try again.');
    } finally {
      setIsBusy(false);
    }
  };

  /**
   * @param {string} property
   * @param {boolean} value
   * @returns {void}
   */
  const handleGDPRChange = (property, value) => {
    if (property === 'inGDPRCountry') {
      setInGDPRCountry(value);
    } else if (property === 'gdprReadConsent') {
      setGdprReadConsent(value);
    }
  };

  useEffect(() => {
    document.title = 'Letters Portal - GDPR';
    DEV_MODE || auth.isAccountAuth() ? void 0 : navigate('/notFound');
  }, []);

  return (
    <main className='lsn-page lsn-page-gdpr'>
      <Heading className="text-center no-focus-outline" tabIndex={0}>
        GDPR
      </Heading>
      <From
        isBusy={isBusy}
        hasBorder
        onSubmit={handleFormSubmit}
        formAttr={{
          name: 'gdprForm',
          title: 'GDPR',
        }}
        buttons={
          <Button
            type="submit"
            primary
            isBusy={isBusy}
            disabled={inGDPRCountry === null || (inGDPRCountry && !gdprReadConsent)}
            onClick={() => {
              document.forms.namedItem('gdprForm')?.checkValidity();
            }}
          >
            Agree & Continue
          </Button>}
      >
        <p hidden={!formErrorMessage} className="form-errors text-center color-red" role="alert">
          {formErrorMessage}
        </p>
        <GDPR gdpr={{ inGDPRCountry, gdprReadConsent }} onChange={handleGDPRChange} />
      </From>
    </main>
  );
};

export default GDPRPage;
